import React, { ReactNode } from 'react';

import './footer-card.scss';

interface Props {
  children: ReactNode;
}

const FooterCard = ({ children }: Props) => (
  <div className="footer-card">
    <div className="container">
      <div className="card card--light card--raised card--full card--cushion card--offset-bottom-md on-top">
        <div className="card__contents  card__contents--lg  layout">
          {children}
        </div>
      </div>
    </div>
  </div>
);

export default FooterCard;
